import { render, staticRenderFns } from "./TagCategory.vue?vue&type=template&id=5ac61eb9&scoped=true"
import script from "./TagCategory.vue?vue&type=script&lang=js"
export * from "./TagCategory.vue?vue&type=script&lang=js"
import style0 from "./TagCategory.vue?vue&type=style&index=0&id=5ac61eb9&prod&lang=css"
import style1 from "./TagCategory.vue?vue&type=style&index=1&id=5ac61eb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac61eb9",
  null
  
)

export default component.exports